import { Typography } from "src/latest/src/components";

type Props = {
    value: any;
};

export function KeyValueContent({ value }: Props) {
    return (
        <div className="d-flex">
            {value.map((item: any) =>
                Object.values(item).map((v, j) => (
                    <>
                        <Typography
                            variant={`size-${j % 2 === 0 ? "16" : "12"}`}
                            weight={`${j % 2 === 0 ? "regular" : "bold"}`}
                            color="color-2"
                            className={`therapist-client-profile__value-first ${
                                j % 2 !== 0
                                    ? "therapist-client-profile__value-key"
                                    : ""
                            }`}
                        >
                            {v}
                        </Typography>
                    </>
                ))
            )}
        </div>
    );
}
